<template>
  <div class="grid-view app-main-page-tab">
    <div class="main-content">
      <div class="app-main-inner-row">
        <el-form :inline="true" label-width="80px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_BusinessType') + ':'">
            <cargo-advance-select
              :select-type="selectTypeNames.local_cache_SystemConstants$LOBS"
              :show-custom-label-in-option="true"
              :default-value="searchConditions.lob"
              style="width: 200px"
              @parentCallBack="lobChangeHandler"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.BusinessMode') + ':'">
            <cargo-advance-select
              :disabled="!searchConditions.lob"
              filterable
              callback-method-type="value"
              :static-options="operateTypeList"
              :default-value="searchConditions.operateType"
              tag-name="chineseName"
              tag-value="code"
              style="width:200px;"
              @parentCallBack="onOperateTypeChange"
            />
          </el-form-item>
          <el-form-item label-width="110px" :label="$t('CargoMsg.Cargo_CustomJobType') + ':'">
            <cargo-advance-select
              :disabled="!searchConditions.lob"
              :select-type="selectTypeNames.basic_data_CutomJobType"
              filterable
              :method-params="{type:searchConditions.lob, active: true}"
              :default-value="searchConditions.customJobType"
              style="width: 200px"
              @parentCallBack="p=>{searchConditions.customJobType=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AirlineCode') + ':'">
            <cargo-advance-select
              v-if="isSea||isAir||isIe"
              :disabled="!searchConditions.lob"
              :select-type="selectTypeNames.basic_data_Region"
              filterable
              :default-value="searchConditions.region"
              tag-name="code"
              style="width: 200px"
              @parentCallBack="p=>{searchConditions.region=p.value}"
            />
            <cargo-advance-select
              v-else
              :disabled="!searchConditions.lob"
              :select-type="selectTypeNames.basic_data_RailwayLine"
              filterable
              :default-value="searchConditions.region"
              tag-name="code"
              style="width: 200px"
              @parentCallBack="p=>{searchConditions.region=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.AirlineChineseName') + ':'">
            <cargo-advance-select
              v-if="isSea||isAir||isIe"
              :disabled="!searchConditions.lob"
              :select-type="selectTypeNames.basic_data_Region"
              filterable
              :default-value="region2"
              tag-name="name"
              style="width: 200px"
              @parentCallBack="p=>{region2=p.value}"
            />
            <cargo-advance-select
              v-else
              :disabled="!searchConditions.lob"
              :select-type="selectTypeNames.basic_data_RailwayLine"
              filterable
              :default-value="region2"
              tag-name="name"
              style="width: 200px"
              @parentCallBack="p=>{region2=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.DeparturePortCode') + ':'">
            <cargo-advance-select
              v-if="isSea||isAir||isIe"
              :disabled="!searchConditions.lob"
              :select-type="isSea||isIe?selectTypeNames.static_data_Seaport:selectTypeNames.static_data_Airport"
              :static-options="isSea||isIe?allSeaport:allAirport"
              filterable
              :callback-params="{key:'loadingPort'}"
              :default-value="searchConditions.loadingPort"
              tag-name="code"
              style="width: 200px"
              @parentCallBack="setQueryData"
            />
            <cargo-advance-select
              v-else
              :disabled="!searchConditions.lob"
              :select-type="selectTypeNames.static_data_RailwayStation"
              :static-options="allRailwayStation"
              filterable
              :callback-params="{key:'loadingPort'}"
              :default-value="searchConditions.loadingPort"
              tag-name="code"
              style="width: 200px"
              @parentCallBack="setQueryData"
            />
          </el-form-item>
          <el-form-item label-width="90px" :label="$t('SystemMaintenance.OriginPortEnName') + ':'">
            <cargo-advance-select
              v-if="isSea||isAir||isIe"
              :disabled="!searchConditions.lob"
              :select-type="isSea||isIe?selectTypeNames.static_data_Seaport:selectTypeNames.static_data_Airport"
              :static-options="isSea||isIe?allSeaport:allAirport"
              filterable
              :default-value="port2"
              tag-name="englishName"
              style="width: 200px"
              @parentCallBack="p=>{port2=p.value}"
            />
            <cargo-advance-select
              v-else
              :disabled="!searchConditions.lob"
              :select-type="selectTypeNames.static_data_RailwayStation"
              :static-options="allRailwayStation"
              filterable
              :default-value="port2"
              tag-name="englishName"
              style="width: 200px"
              @parentCallBack="p=>{port2=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PortCodeOfDischarge') + ':'">
            <cargo-advance-select
              v-if="isSea||isAir||isIe"
              :disabled="!searchConditions.lob"
              :select-type="isSea||isIe?selectTypeNames.static_data_Seaport:selectTypeNames.static_data_Airport"
              :static-options="isSea||isIe?allSeaport:allAirport"
              filterable
              :callback-params="{key:'port'}"
              :default-value="searchConditions.port"
              tag-name="code"
              style="width: 200px"
              @parentCallBack="setQueryData"
            />
            <cargo-advance-select
              v-else
              :disabled="!searchConditions.lob"
              :select-type="selectTypeNames.static_data_RailwayStation"
              :static-options="allRailwayStation"
              filterable
              :callback-params="{key:'port'}"
              :default-value="searchConditions.port"
              tag-name="code"
              style="width: 200px"
              @parentCallBack="setQueryData"
            />
          </el-form-item>
          <el-form-item label-width="90px" :label="$t('SystemMaintenance.UnloadingEortEnName') + ':'">
            <cargo-advance-select
              v-if="isSea||isAir||isIe"
              :disabled="!searchConditions.lob"
              :select-type="isSea||isIe?selectTypeNames.static_data_Seaport:selectTypeNames.static_data_Airport"
              :static-options="isSea||isIe?allSeaport:allAirport"
              filterable
              :default-value="port2"
              tag-name="englishName"
              style="width: 200px"
              @parentCallBack="p=>{port2=p.value}"
            />
            <cargo-advance-select
              v-else
              :disabled="!searchConditions.lob"
              :select-type="selectTypeNames.static_data_RailwayStation"
              :static-options="allRailwayStation"
              filterable
              :default-value="port2"
              tag-name="englishName"
              style="width: 200px"
              @parentCallBack="p=>{port2=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.WarehouseSupplier') + ':'">
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{warehouse:true,active:true}"
              :default-value="searchConditions.warehouseId||''"
              style="width: 200px;"
              @parentCallBack="onWarehouseIdChange"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.WareHouseName') + ':'">
            <el-select v-model="searchConditions.warehouseName" filterable :clearable="true" :placeholder="$t('CargoMsg.Cargo_keyWordsTip')" style="width: 200px;">
              <el-option
                v-for="(item,index) in warehouseNameList"
                :key="index"
                :value="item.warehouseName"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomsBroker') + ':'">
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{customsBroker:true,active:true}"
              :default-value="searchConditions.customsBroker||''"
              style="width: 200px;"
              @parentCallBack="p=>{searchConditions.customsBroker=p.value||0}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DestinationAgent') + ':'">
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{overseaAgent:true, active:true}"
              :default-value="searchConditions.destinationAgent||''"
              tag-name="englishName"
              style="width: 200px;"
              @parentCallBack="p=>{searchConditions.destinationAgent=p.value||0}"
            />
          </el-form-item>
          <el-form-item label-width="100px" :label="$t('SeaExport.opOffice') + ':'">
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Office_All"
              filterable
              :static-options="officeList"
              :default-value="searchConditions.opOffice"
              tag-name="code"
              style="width: 200px"
              @parentCallBack="p=>{searchConditions.opOffice=p.value}"
            />
          </el-form-item>
          <el-form-item label-width="100px" :label="$t('CargoMsg.Cargo_Carrier') + ':'">
            <cargo-company-select
              v-if="searchConditions.lob === 'SE'"
              :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
              :default-value="searchConditions.carrierId"
              custom-style="width: 200px"
              @change="p=>{searchConditions.carrierId=p.value}"
            />
            <cargo-company-select
              v-else-if="routeWareHouseForm.lob === 'SI'"
              :method-params="{companyLob:'seaImport',seaCmp:true,active:true}"
              :default-value="searchConditions.carrierId"
              custom-style="width: 200px"
              @change="p=>{searchConditions.carrierId=p.value}"
            />
            <cargo-company-select
              v-else-if="routeWareHouseForm.lob === 'AE'"
              :method-params="{companyLob:'airExport',airCmp:true,active:true}"
              :default-value="searchConditions.carrierId"
              custom-style="width: 200px"
              @change="p=>{searchConditions.carrierId=p.value}"
            />
            <cargo-company-select
              v-else-if="routeWareHouseForm.lob === 'AI'"
              :method-params="{companyLob:'airImport',airCmp:true,active:true}"
              :default-value="searchConditions.carrierId"
              custom-style="width: 200px"
              @change="p=>{searchConditions.carrierId=p.value}"
            />
            <cargo-company-select
              v-else-if="searchConditions.lob === 'IE' && searchConditions.operateType === 'IC'"
              :method-params="{companyLob:'integratedJob',truckCmp:true,active:true}"
              :default-value="searchConditions.carrierId"
              custom-style="width: 200px"
              @change="p=>{searchConditions.carrierId=p.value}"
            />
            <el-select v-else disabled value placeholder=" " style="width: 200px" />
          </el-form-item>
          <el-form-item label-width="0">
            <el-checkbox :value="config.value==='1'" @input="onConfigInput">{{ $t('SystemMaintenance.ConfigApplyRemoteBooking') }}</el-checkbox>
          </el-form-item>
          <el-form-item label-width="0">
            <el-button type="primary" @click="fetchRouteWareHouseMappingList(1)">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
            <el-button type="primary" @click="popRouteWareHouseAddDialog">{{ $t('common.btn.new') }}</el-button>
            <el-button type="primary" @click="popRouteWareHouseEditFormDialog">{{ $t('common.btn.edit') }}</el-button>
            <el-button type="danger" @click="toDelete">{{ $t('common.btn.delete') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="260302"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="searchConditions.total>0"
          config-module="260302"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchRouteWareHouseMappingList"
        />
      </div>
    </div>
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="isShowRouteWareHouseMaintain"
      :title="$t('CargoMsg.Cargo_RouteAndWarehouseConfiguration')"
      inline-message
      width="1100px"
    >
      <div class="flex-column">
        <div>
          <span class="title">{{ $t('SystemMaintenance.MatchingCriteriaSelection') }}</span>
          <el-tooltip :content="$t('SystemMaintenance.MatchingCriteriaSelectionTip')" placement="right">
            <i class="el-icon-warning" style="color: #E6A23C;font-size: 14px;margin-left: 5px;" />
          </el-tooltip>
        </div>
        <el-form label-width="100px" inline style="margin-top: 5px;">
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SeaExport.opOffice') }}</div>
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Office_All"
              filterable
              :multiple="true"
              :static-options="officeList"
              :default-multiple-value="toNumArray(routeWareHouseForm.multipleOpOffice)"
              tag-name="code"
              style="width: 250px"
              @parentCallBack="p=>{routeWareHouseForm.multipleOpOffice=toTxt(p.value)}"
            />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.PleaseSelectARoute') }}</div>
            <cargo-advance-select
              v-if="isSeaOfForm||isAirOfForm||isIeOfForm"
              :select-type="selectTypeNames.basic_data_Region"
              :static-options="isSeaOfForm||isIeOfForm?seaRegionList:airRegionList"
              filterable
              :multiple="true"
              :default-multiple-value="toArray(routeWareHouseForm.regionCode)"
              tag-name="name"
              style="width: 250px"
              @parentCallBack="onMultipleRegionChange"
            />
            <cargo-advance-select
              v-else
              :select-type="selectTypeNames.basic_data_RailwayLine"
              filterable
              :multiple="true"
              :default-multiple-value="toArray(routeWareHouseForm.regionCode)"
              tag-name="name"
              style="width: 250px"
              @parentCallBack="p=>{routeWareHouseForm.regionCode=toTxt(p.value)}"
            />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('CargoMsg.Cargo_BusinessType') }}</div>
            <cargo-advance-select
              :select-type="selectTypeNames.local_cache_SystemConstants$LOBS"
              :show-custom-label-in-option="true"
              :default-value="routeWareHouseForm.lob"
              style="width: 250px"
              :clearable="false"
              @parentCallBack="p=>{ddlLobChangeHandler(p.value)}"
            />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('CargoMsg.Cargo_BusinessModel') }}</div>
            <cargo-advance-select
              filterable
              :multiple="true"
              callback-method-type="value"
              :static-options="operateTypeListOfForm"
              :default-multiple-value="isAirOfForm ? toNumArray(routeWareHouseForm.multipleOperateType) : toArray(routeWareHouseForm.multipleOperateType)"
              tag-name="chineseName"
              tag-value="code"
              style="width:250px;"
              @parentCallBack="onFormOperateTypeChange"
            />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.PleaseSelectDeparturePort') }}</div>
            <cargo-advance-select
              v-if="isSeaOfForm||isIeOfForm"
              :select-type="selectTypeNames.basic_data_Seaport"
              :static-options="portList"
              filterable
              :multiple="true"
              :default-multiple-value="toArray(routeWareHouseForm.multipleLoadingPortCode)"
              tag-name="englishName"
              style="width: 250px"
              @parentCallBack="p=>{routeWareHouseForm.multipleLoadingPortCode=toTxt(p.value)}"
            />
            <cargo-advance-select
              v-else-if="isAirOfForm"
              :select-type="selectTypeNames.basic_data_Airport"
              :static-options="portList"
              filterable
              :multiple="true"
              :default-multiple-value="toArray(routeWareHouseForm.multipleLoadingPortCode)"
              tag-name="englishName"
              style="width: 250px"
              @parentCallBack="p=>{routeWareHouseForm.multipleLoadingPortCode=toTxt(p.value)}"
            />
            <cargo-advance-select
              v-else
              :select-type="selectTypeNames.basic_data_RailwayStation"
              filterable
              :multiple="true"
              :default-multiple-value="toArray(routeWareHouseForm.multipleLoadingPortCode)"
              tag-name="englishName"
              style="width: 250px"
              @parentCallBack="p=>{routeWareHouseForm.multipleLoadingPortCode=toTxt(p.value)}"
            />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.PleaseSelectUnloadingPort') }}</div>
            <cargo-advance-select
              v-if="isSeaOfForm||isIeOfForm"
              :select-type="selectTypeNames.basic_data_Seaport"
              :static-options="portList"
              filterable
              :multiple="true"
              :default-multiple-value="toArray(routeWareHouseForm.multiplePortCode)"
              tag-name="englishName"
              style="width: 250px"
              @parentCallBack="p=>{routeWareHouseForm.multiplePortCode=toTxt(p.value)}"
            />
            <cargo-advance-select
              v-else-if="isAirOfForm"
              :select-type="selectTypeNames.basic_data_Airport"
              :static-options="portList"
              filterable
              :multiple="true"
              :default-multiple-value="toArray(routeWareHouseForm.multiplePortCode)"
              tag-name="englishName"
              style="width: 250px"
              @parentCallBack="p=>{routeWareHouseForm.multiplePortCode=toTxt(p.value)}"
            />
            <cargo-advance-select
              v-else
              :select-type="selectTypeNames.basic_data_RailwayStation"
              filterable
              :multiple="true"
              :default-multiple-value="toArray(routeWareHouseForm.multiplePortCode)"
              tag-name="englishName"
              style="width: 250px"
              @parentCallBack="p=>{routeWareHouseForm.multiplePortCode=toTxt(p.value)}"
            />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SeaExport.CustomJobType') }}</div>
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_CutomJobType"
              filterable
              :multiple="true"
              :method-params="{type:routeWareHouseForm.lob, active: true}"
              :default-multiple-value="toArray(routeWareHouseForm.multipleCustomJobType)"
              style="width: 250px"
              @parentCallBack="p=>{routeWareHouseForm.multipleCustomJobType=toTxt(p.value)}"
            />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.PleaseSelectCarrier') }}</div>
            <cargo-company-select
              v-if="routeWareHouseForm.lob === 'SE'"
              :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
              multiple
              :default-multiple-value="toNumArray(routeWareHouseForm.multipleCarrierId)"
              custom-style="width: 250px"
              @change="p=>{routeWareHouseForm.multipleCarrierId=toTxt(p.value)}"
            />
            <cargo-company-select
              v-else-if="routeWareHouseForm.lob === 'SI'"
              :method-params="{companyLob:'seaImport',seaCmp:true,active:true}"
              multiple
              :default-multiple-value="toNumArray(routeWareHouseForm.multipleCarrierId)"
              custom-style="width: 250px"
              @change="p=>{routeWareHouseForm.multipleCarrierId=toTxt(p.value)}"
            />
            <cargo-company-select
              v-else-if="routeWareHouseForm.lob === 'AE'"
              :method-params="{companyLob:'airExport',airCmp:true,active:true}"
              multiple
              :default-multiple-value="toNumArray(routeWareHouseForm.multipleCarrierId)"
              custom-style="width: 250px"
              @change="p=>{routeWareHouseForm.multipleCarrierId=toTxt(p.value)}"
            />
            <cargo-company-select
              v-else-if="routeWareHouseForm.lob === 'AI'"
              :method-params="{companyLob:'airImport',airCmp:true,active:true}"
              multiple
              :default-multiple-value="toNumArray(routeWareHouseForm.multipleCarrierId)"
              custom-style="width: 250px"
              @change="p=>{routeWareHouseForm.multipleCarrierId=toTxt(p.value)}"
            />
            <cargo-company-select
              v-else-if="routeWareHouseForm.lob === 'IE' && routeWareHouseForm.multipleOperateType.indexOf('IC') > -1"
              :method-params="{companyLob:'integratedJob',truckCmp:true,active:true}"
              multiple
              :default-multiple-value="toNumArray(routeWareHouseForm.multipleCarrierId)"
              custom-style="width: 250px"
              @change="p=>{routeWareHouseForm.multipleCarrierId=toTxt(p.value)}"
            />
            <el-select v-else disabled value placeholder=" " style="width: 250px" />
          </el-form-item>
        </el-form>
        <div style="width: calc(100% + 20px);margin-left: -10px;margin-top: 10px;margin-bottom: 10px;;border-top: 1px solid #E3E3E3;" />
        <div style="display: flex;margin-top: 10px;">
          <div style="width: 350px;">
            <span class="title">{{ $t('SystemMaintenance.PresetValueConfiguration') }}</span>
            <el-tooltip :content="$t('SystemMaintenance.PresetValueConfigurationTip')" placement="right">
              <i class="el-icon-warning" style="color: #E6A23C;font-size: 14px;margin-left: 5px;" />
            </el-tooltip>
          </div>
          <div style="margin-left: 18px;">
            <span class="title">{{ $t('SystemMaintenance.SetLeadTimeBasedOnETDTime') }}</span>
          </div>
        </div>
        <el-form label-width="100px" inline style="margin-top: 5px;">
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.AssociatedWarehouseSupplier') }}</div>
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{warehouse:true,active:true}"
              :default-value="routeWareHouseForm.warehouseId"
              style="width: 250px;"
              @parentCallBack="onWarehouseIdFormChange"
            />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SeaExport.CargosExpectedArrivalDate') }}</div>
            <div style="width: 250px">
              <el-input-number v-model="routeWareHouseForm.arriveDateIncrement" :disabled="!isSeAe" :precision="0" :min="0" style="width: 100px" />
              <span style="margin-left: 20px;">{{ $t('CargoMsg.Cargo_Days') }}</span>
            </div>
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SeaExport.CustomerClosingTime') }}</div>
            <div style="width: 250px">
              <el-input-number v-model="routeWareHouseForm.customerFileCutoffIncrement" :disabled="!isSeAe" :precision="0" :min="0" style="width: 100px" />
              <span style="margin-left: 20px;">{{ $t('CargoMsg.Cargo_Days') }}</span>
            </div>
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.AssociatedWarehouseName') }}</div>
            <el-select v-model="routeWareHouseForm.warehouseName" filterable :clearable="true" :placeholder="$t('CargoMsg.Cargo_keyWordsTip')" style="width: 250px;">
              <el-option
                v-for="(item,index) in warehouseNameFormList"
                :key="index"
                :value="item.warehouseName"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('Pricing.ClosingTime') }}</div>
            <div style="width: 250px">
              <el-input-number v-model="routeWareHouseForm.fileCutoffIncrement" :disabled="!isSeAe" :precision="0" :min="0" style="width: 100px" />
              <span style="margin-left: 20px;">{{ $t('CargoMsg.Cargo_Days') }}</span>
            </div>
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SeaExport.CustomerCyCutOffDate') }}</div>
            <div style="width: 250px">
              <el-input-number v-model="routeWareHouseForm.customerCutoffIncrement" :disabled="!isSeAe" :precision="0" :min="0" style="width: 100px" />
              <span style="margin-left: 20px;">{{ $t('CargoMsg.Cargo_Days') }}</span>
            </div>
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.RelatedCustomsBroker') }}</div>
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              :callback-params="{key:'customsBroker',active:true}"
              callback-method-type="value"
              :default-value="routeWareHouseForm.customsBroker"
              style="width: 250px;"
              @parentCallBack="getValueFromChild"
            />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.CustomsClosingTime') }}</div>
            <div style="width: 250px">
              <el-input-number v-model="routeWareHouseForm.customCutoffIncrement" :disabled="!isSeAe" :precision="0" :min="0" style="width: 100px" />
              <span style="margin-left: 20px;">{{ $t('CargoMsg.Cargo_Days') }}</span>
            </div>
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SeaExport.CustomerShutOutDate') }}</div>
            <div style="width: 250px">
              <el-input-number v-model="routeWareHouseForm.customerShutoutIncrement" :disabled="!isSeAe" :precision="0" :min="0" style="width: 100px" />
              <span style="margin-left: 20px;">{{ $t('CargoMsg.Cargo_Days') }}</span>
            </div>
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.RelatedDestinationAgent') }}</div>
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              :callback-params="{key:'destinationAgent',active:true}"
              callback-method-type="value"
              :default-value="routeWareHouseForm.destinationAgent"
              style="width: 250px;"
              @parentCallBack="getValueFromChild"
            />
          </el-form-item>
          <el-form-item label=" ">
            <el-checkbox v-model="routeWareHouseForm.dateCalculateIncludeCurrentDay">{{ $t('SystemMaintenance.CalculateDateIncludeETDTheDay') }}</el-checkbox>
            <el-checkbox v-model="routeWareHouseForm.calculateIncludeEtdIsWeekend">{{ $t('SystemMaintenance.CalculateIncludeEtdIsWeekend') }}</el-checkbox>
          </el-form-item>
        </el-form>
        <el-form label-width="100px" inline style="margin-top: 5px;">
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.DefaultConfigurationNotes') }}</div>
            <el-input v-model="routeWareHouseForm.remark" type="textarea" rows="3" style="width: 250px" />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.PortRequirementBillRequirements') }}</div>
            <div class="flex-column" style="width: 250px">
              <el-input v-model="routeWareHouseForm.portRequirement" type="textarea" rows="3" />
              <div style="display: flex;line-height: 18px;margin-top: 5px;cursor: pointer;" @click="openAttachment">
                <i class="el-icon-upload2" style="font-size: 18px;" />
                <div style="font-size: 14px;">{{ $t('SystemMaintenance.RelatedInstructionsAttachments') }}</div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="submitRouteWareHouseManagement">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="routeWareHouseForm"
      :lob="routeWareHouseForm.lob"
      :show-all="true"
    />
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as routeWarehouseMappingApi from '@/api/sysManage/baseConfig/routeWarehouseMapping'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { IE_TYPES } from '@/class/cargo/model/parameters/ContainerLoadType'
import { getCacheListByKey, getFilterCacheList, getObjectByCache } from '@/utils/basicDataCache'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { Company } from '@/class/model/mdm/Company'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { getOfficeConfigByName, saveOfficeConfigFunc } from '@/api/user'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'RouteAndWarehouseConfiguration',
  components: { cargoAdvanceSelect, cargoCompanySelect, cargoCloudFileUpload },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      searchConditions: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        lob: '',
        operateType: '',
        customJobType: '',
        region: '',
        loadingPort: '',
        port: '',
        warehouseId: 0,
        warehouseName: '',
        customsBroker: 0,
        destinationAgent: 0,
        opOffice: 0,
        carrierId: 0
      },
      region2: '',
      loadingPort2: '',
      port2: '',
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('sysManage.baseConfig.routeWareHouseConfiguration.regionCode'),
          field: 'regionCode',
          width: 150
        },
        {
          headerName: this.$t('SystemMaintenance.AirlineChineseName'),
          field: 'multipleRegionChineseName',
          width: 200,
          valueFormatter: params => this.getMultipleRegionName(params.data),
          filterParams: {},
          filterValueGetter: params => this.getMultipleRegionName(params.data)
        },
        {
          headerName: this.$t('SystemMaintenance.DeparturePortCode'),
          field: 'multipleLoadingPortCode',
          width: 150
        },
        {
          headerName: this.$t('SystemMaintenance.OriginPortEnName'),
          field: 'multipleLoadingPortCodeEnglishName',
          width: 200,
          valueFormatter: params => this.getLoadingPortEnglishName(params.data),
          filterParams: {},
          filterValueGetter: params => this.getLoadingPortEnglishName(params.data)
        },
        {
          headerName: this.$t('SeaExport.PortCodeOfDischarge'),
          field: 'multiplePortCode',
          width: 150
        },
        {
          headerName: this.$t('SystemMaintenance.UnloadingEortEnName'),
          field: 'multiplePortCodeEnglishName',
          width: 200,
          valueFormatter: params => this.getPortEnglishName(params.data),
          filterParams: {},
          filterValueGetter: params => this.getPortEnglishName(params.data)
        },
        {
          headerName: this.$t('SystemMaintenance.BusinessType'),
          field: 'lob',
          width: 100,
          valueFormatter: (params) => {
            const state = `SystemConstants.getCommonState(params.value, SystemConstants.LOBS)`
            if (state) {
              return this.$store.getters.language === 'zh' ? state.chineseName : state.englishName
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('SystemMaintenance.BusinessMode'),
          field: 'multipleOperateType',
          width: 100,
          valueFormatter: params => this.operateTypeLabelFunc(params.data),
          filterParams: {},
          filterValueGetter: params => this.operateTypeLabelFunc(params.data)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CustomJobType'),
          field: 'multipleCustomJobType',
          width: 200,
          valueFormatter: params => {
            if (params.value) {
              const values = params.value.split(',')
              return Array.from(values, p => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', p, 'name')).join(',')
            }
            return ''
          }
        },
        {
          headerName: this.$t('sysManage.baseConfig.routeWareHouseConfiguration.warehouse'),
          field: 'warehouseId',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.WareHouseName'),
          width: 150,
          field: 'warehouseName'
        },
        {
          headerName: this.$t('SeaExport.CustomsBroker'),
          field: 'customsBroker',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.DestinationAgent'),
          field: 'destinationAgent',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SystemMaintenance.DefaultConfigurationNotes'),
          width: 150,
          field: 'remark'
        },
        {
          headerName: this.$t('SeaExport.opOffice'),
          field: 'multipleOpOffice',
          width: 200,
          valueFormatter: params => {
            if (params.value) {
              const values = params.value.split(',')
              return Array.from(values, p => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(p), 'code')).join(',')
            }
            return ''
          }
        },
        {
          headerName: this.$t('SeaExport.Carrier'),
          field: 'multipleCarrierId',
          width: 200,
          valueFormatter: params => {
            if (params.value) {
              const values = params.value.split(',')
              return Array.from(values, p => CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(p), 'auto_5')).join(',')
            }
            return ''
          }
        },
        {
          headerName: this.$t('SeaExport.CargosExpectedArrivalDate'),
          field: 'arriveDateIncrement',
          width: 100,
          valueFormatter: params => (params.value || 0) + this.$t('CargoMsg.Cargo_Days')
        },
        {
          headerName: this.$t('SeaExport.CustomerClosingTime'),
          field: 'customerFileCutoffIncrement',
          width: 100,
          valueFormatter: params => (params.value || 0) + this.$t('CargoMsg.Cargo_Days')
        },
        {
          headerName: this.$t('Pricing.ClosingTime'),
          field: 'fileCutoffIncrement',
          width: 100,
          valueFormatter: params => (params.value || 0) + this.$t('CargoMsg.Cargo_Days')
        },
        {
          headerName: this.$t('SeaExport.CustomerCyCutOffDate'),
          field: 'customerCutoffIncrement',
          width: 100,
          valueFormatter: params => (params.value || 0) + this.$t('CargoMsg.Cargo_Days')
        },
        {
          headerName: this.$t('SystemMaintenance.CustomsClosingTime'),
          field: 'customCutoffIncrement',
          width: 100,
          valueFormatter: params => (params.value || 0) + this.$t('CargoMsg.Cargo_Days')
        },
        {
          headerName: this.$t('SeaExport.CustomerShutOutDate'),
          field: 'customerShutoutIncrement',
          width: 100,
          valueFormatter: params => (params.value || 0) + this.$t('CargoMsg.Cargo_Days')
        },
        {
          headerName: this.$t('SystemMaintenance.CalculateDateIncludeETDTheDay'),
          field: 'dateCalculateIncludeCurrentDay',
          width: 100,
          valueFormatter: params => ColumnUtils.booleanColumnLabelFunc(params.value)
        },
        {
          headerName: this.$t('SystemMaintenance.CalculateIncludeEtdIsWeekend'),
          field: 'calculateIncludeEtdIsWeekend',
          width: 100,
          valueFormatter: params => ColumnUtils.booleanColumnLabelFunc(params.value)
        },
        {
          headerName: this.$t('SystemMaintenance.PortRequirementBillRequirements'),
          field: 'portRequirement',
          width: 150
        }
      ],
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      routeWareHouseForm: {
        uuid: '',
        regionCode: '',
        warehouseId: 0,
        remark: '',
        lob: '',
        multipleOperateType: '',
        multipleCustomJobType: '',
        multipleLoadingPortCode: '',
        multiplePortCode: '',
        warehouseName: '',
        customsBroker: 0,
        destinationAgent: 0,
        multipleOpOffice: '',
        multipleCarrierId: '',
        arriveDateIncrement: 0,
        customerFileCutoffIncrement: 0,
        fileCutoffIncrement: 0,
        customerCutoffIncrement: 0,
        customCutoffIncrement: 0,
        customerShutoutIncrement: 0,
        portRequirement: '',
        dateCalculateIncludeCurrentDay: false,
        calculateIncludeEtdIsWeekend: true
      },
      isShowRouteWareHouseMaintain: false,
      operateTypeList: [],
      warehouseNameList: [],
      operateTypeListOfForm: [],
      portList: [],
      seaRegionList: [],
      airRegionList: [],
      warehouseNameFormList: [],
      config: {},
      officeList: [],
      cloudFile: {
        visible: false,
        job: {},
        lob: 'SE',
        newFile: null
      },
      allSeaport: [],
      allAirport: [],
      allRailwayStation: []
    }
  },
  computed: {
    isSea() {
      return this.searchConditions.lob === 'SE' || this.searchConditions.lob === 'SI'
    },
    isAir() {
      return this.searchConditions.lob === 'AE' || this.searchConditions.lob === 'AI'
    },
    isIe() {
      return this.searchConditions.lob === 'IE'
    },
    isSeaOfForm() {
      return this.routeWareHouseForm.lob === 'SE' || this.routeWareHouseForm.lob === 'SI'
    },
    isAirOfForm() {
      return this.routeWareHouseForm.lob === 'AE' || this.routeWareHouseForm.lob === 'AI'
    },
    isIeOfForm() {
      return this.routeWareHouseForm.lob === 'IE'
    },
    isSeAe() {
      return this.routeWareHouseForm.lob === 'SE' || this.routeWareHouseForm.lob === 'AE'
    }
  },
  created() {
    this.officeList = getFilterCacheList(TYPE_NAMES.basic_data_Office_All, p => p.officeId !== 1)
    /* 海运关联航线 */
    const seaportList = getCacheListByKey(TYPE_NAMES.basic_data_Seaport)
    const seaRegionCodeSet = new Set()
    for (const seaport of seaportList) {
      if (seaport.region) {
        seaRegionCodeSet.add(seaport.region)
      }
    }
    this.seaRegionList = getFilterCacheList(TYPE_NAMES.basic_data_Region, p => seaRegionCodeSet.has(p.code))
    /* 空运关联航线 */
    const airportList = getCacheListByKey(TYPE_NAMES.basic_data_Airport)
    const airRegionCodeSet = new Set()
    for (const airport of airportList) {
      if (airport.region) {
        airRegionCodeSet.add(airport.region)
      }
    }
    this.airRegionList = getFilterCacheList(TYPE_NAMES.basic_data_Region, p => airRegionCodeSet.has(p.code))

    this.allSeaport = getCacheListByKey(TYPE_NAMES.basic_data_Seaport)
    this.allAirport = getCacheListByKey(TYPE_NAMES.basic_data_Airport)
    this.allRailwayStation = getCacheListByKey(TYPE_NAMES.basic_data_RailwayStation)
  },
  mounted() {
    this.fetchRouteWareHouseMappingList()
    this.loadConfig()
  },
  methods: {
    setQueryData(obj) {
      this.searchConditions[obj.key] = obj.value
    },
    lobChangeHandler(data) {
      this.searchConditions.lob = data.value
      this.searchConditions.operateType = ''
      switch (data.value) {
        case 'SE':
        case 'RE':
        case 'RI':
          this.operateTypeList = Array.from(SeaExportConstants.CONTAINER_LOAD_TYPES)
          break
        case 'SI':
          this.operateTypeList = ImportConstants._cargoTypeInputList
          break
        case 'AE':
          this.operateTypeList = AirExportConstants.BUSINESS_MODELS
          break
        case 'AI':
          this.operateTypeList = AirExportConstants.BUSINESS_MODELS
          break
        case 'IE':
          this.operateTypeList = IE_TYPES
          break
      }
      this.searchConditions.customJobType = ''
      this.searchConditions.region = ''
      this.region2 = ''
      this.searchConditions.loadingPort = ''
      this.loadingPort2 = ''
      this.searchConditions.port = ''
      this.port2 = ''
      this.searchConditions.carrierId = 0
    },
    ddlLobChangeHandler(lob) {
      if (lob) {
        this.routeWareHouseForm.lob = lob
      }
      this.routeWareHouseForm.multipleOperateType = ''
      switch (this.routeWareHouseForm.lob) {
        case 'SE':
        case 'RE':
        case 'RI':
          this.operateTypeListOfForm = Array.from(SeaExportConstants.CONTAINER_LOAD_TYPES)
          break
        case 'SI':
          this.operateTypeListOfForm = ImportConstants._cargoTypeInputList
          break
        case 'AE':
          this.operateTypeListOfForm = AirExportConstants.BUSINESS_MODELS
          break
        case 'AI':
          this.operateTypeListOfForm = AirExportConstants.BUSINESS_MODELS
          break
        case 'IE':
          this.operateTypeListOfForm = IE_TYPES
          break
      }
      this.routeWareHouseForm.multipleCustomJobType = ''
      if (this.isSeaOfForm || this.isAirOfForm || this.isIeOfForm) {
        this.onMultipleRegionChange({ value: [] })
      } else {
        this.routeWareHouseForm.regionCode = ''
        this.routeWareHouseForm.multipleLoadingPortCode = ''
        this.routeWareHouseForm.multiplePortCode = ''
      }
      if (!this.routeWareHouseForm.uuid || lob) {
        this.routeWareHouseForm.multipleCarrierId = ''
        if (this.routeWareHouseForm.lob === 'SE' || this.routeWareHouseForm.lob === 'AE') {
          this.routeWareHouseForm.arriveDateIncrement = 3
          this.routeWareHouseForm.customerFileCutoffIncrement = 3
          this.routeWareHouseForm.fileCutoffIncrement = 3
          this.routeWareHouseForm.customerCutoffIncrement = 3
          this.routeWareHouseForm.customCutoffIncrement = 3
          this.routeWareHouseForm.customerShutoutIncrement = 3
        } else {
          this.routeWareHouseForm.arriveDateIncrement = 0
          this.routeWareHouseForm.customerFileCutoffIncrement = 0
          this.routeWareHouseForm.fileCutoffIncrement = 0
          this.routeWareHouseForm.customerCutoffIncrement = 0
          this.routeWareHouseForm.customCutoffIncrement = 0
          this.routeWareHouseForm.customerShutoutIncrement = 0
        }
      }
    },
    onOperateTypeChange(val) {
      this.searchConditions.operateType = val
      if (this.searchConditions.customJobType) {
        this.searchConditions.customJobType = ''
      } else {
        const cutomJobTypeList = getCacheListByKey(TYPE_NAMES.basic_data_CutomJobType)
        const obj = cutomJobTypeList.find(p => p.type === this.searchConditions.lob && p.containerLoadType === this.searchConditions.operateType)
        if (obj) {
          this.searchConditions.customJobType = obj.code
        }
      }
      if (this.searchConditions.lob === 'IE') {
        this.searchConditions.carrierId = 0
      }
    },
    onFormOperateTypeChange(val) {
      this.routeWareHouseForm.multipleOperateType = this.toTxt(val)
      if (this.routeWareHouseForm.lob === 'IE') {
        if (this.routeWareHouseForm.multipleOperateType.indexOf('IC') < 0) {
          this.routeWareHouseForm.multipleCarrierId = ''
        }
      }
    },
    fetchRouteWareHouseMappingList(pageNum) {
      if (typeof pageNum === 'number') {
        this.searchConditions.pageNum = pageNum
      }
      const regionCodes = this.searchConditions.region ? [this.searchConditions.region] : []
      if (this.region2) {
        const cacheKey = this.isSea || this.isAir || this.isIe ? TYPE_NAMES.basic_data_Region : TYPE_NAMES.basic_data_RailwayLine
        const obj = getObjectByCache(cacheKey, 'code', this.region2)
        if (obj) {
          const regions = getFilterCacheList(cacheKey, p => p.name === obj.name)
          for (const region of regions) {
            regionCodes.push(region.code)
          }
        }
      }
      const loadingPortCodes = this.searchConditions.loadingPort ? [this.searchConditions.loadingPort] : []
      if (this.loadingPort2) {
        const cacheKey = this.isSea || this.isIe ? TYPE_NAMES.basic_data_Seaport : (this.isAir ? TYPE_NAMES.basic_data_Airport : TYPE_NAMES.basic_data_RailwayStation)
        const obj = getObjectByCache(cacheKey, 'code', this.loadingPort2)
        if (obj) {
          const loadingPorts = getFilterCacheList(cacheKey, p => p.englishName === obj.englishName)
          for (const loadingPort of loadingPorts) {
            loadingPortCodes.push(loadingPort.code)
          }
        }
      }
      const portCodes = this.searchConditions.port ? [this.searchConditions.port] : []
      if (this.port2) {
        const cacheKey = this.isSea || this.isIe ? TYPE_NAMES.basic_data_Seaport : (this.isAir ? TYPE_NAMES.basic_data_Airport : TYPE_NAMES.basic_data_RailwayStation)
        const obj = getObjectByCache(cacheKey, 'code', this.port2)
        if (obj) {
          const ports = getFilterCacheList(cacheKey, p => p.englishName === obj.englishName)
          for (const port of ports) {
            portCodes.push(port.code)
          }
        }
      }
      const loading = getLoading4Cxt(this)
      routeWarehouseMappingApi.getList({
        ...this.searchConditions,
        region: '',
        regions: regionCodes.join(','),
        loadingPorts: loadingPortCodes.join(','),
        port: '',
        ports: portCodes.join(',')
      }).then(results => {
        this.rowData = results.data.list
        this.searchConditions.pageNum = results.data.pageNum
        this.searchConditions.total = Number(results.data.total)
      }).finally(() => {
        loading.close()
      })
    },
    popRouteWareHouseAddDialog() {
      this.routeWareHouseForm = this.initForm()
      this.initEditDialog()
      this.isShowRouteWareHouseMaintain = true
    },
    initEditDialog() {
      const data = { ...this.routeWareHouseForm }
      this.ddlLobChangeHandler()
      this.routeWareHouseForm.multipleOperateType = data.multipleOperateType
      this.routeWareHouseForm.multipleCustomJobType = data.multipleCustomJobType
      this.routeWareHouseForm.regionCode = data.regionCode
      if (this.isSeaOfForm || this.isAirOfForm || this.isIeOfForm) {
        this.onMultipleRegionChange({ value: this.toArray(data.regionCode) })
      } else {
        this.routeWareHouseForm.regionCode = data.regionCode
      }
      this.routeWareHouseForm.multipleLoadingPortCode = data.multipleLoadingPortCode
      if (this.routeWareHouseForm.multipleLoadingPortCode && (this.isSeaOfForm || this.isAirOfForm || this.isIeOfForm)) {
        const portCodeList = this.routeWareHouseForm.multipleLoadingPortCode.split(',')
        for (const portCode of portCodeList) {
          const index = this.portList.findIndex(p => p.code === portCode)
          if (index < 0) {
            let port = null
            if (this.isSeaOfForm || this.isIeOfForm) {
              port = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', portCode)
            } else {
              port = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', portCode)
            }
            if (port) {
              this.portList.push(port)
            }
          }
        }
      }
      this.routeWareHouseForm.multiplePortCode = data.multiplePortCode
      if (this.routeWareHouseForm.multiplePortCode && (this.isSeaOfForm || this.isAirOfForm || this.isIeOfForm)) {
        const portCodeList = this.routeWareHouseForm.multiplePortCode.split(',')
        for (const portCode of portCodeList) {
          const index = this.portList.findIndex(p => p.code === portCode)
          if (index < 0) {
            let port = null
            if (this.isSeaOfForm || this.isIeOfForm) {
              port = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', portCode)
            } else {
              port = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', portCode)
            }
            if (port) {
              this.portList.push(port)
            }
          }
        }
      }
    },
    popRouteWareHouseEditFormDialog() {
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const cell = this.gridOptions.api.getFocusedCell()
      const selectedData = cell && nodes[cell.rowIndex] ? nodes[cell.rowIndex].data : null
      if (!selectedData) {
        this.$message.warning(this.$t('Message.PleaseSelectARecord2'))
        return
      }
      this.routeWareHouseForm = { ...selectedData }
      this.initEditDialog()
      this.isShowRouteWareHouseMaintain = true
    },
    toDelete() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseCheckAtLeastOnePieceOfData'))
        return
      }
      const keys = Array.from(selectedRows, p => p.uuid)
      this.$confirm(this.$t('SystemMaintenance.AreYouWantToDelete2', [keys.length]), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        routeWarehouseMappingApi.batchDelete(keys).then(() => {
          this.$message.success(this.$t('SystemMaintenance.DeleteSuccess2'))
          JobUtils.regionPortPresetConfigCache.clear()
          this.fetchRouteWareHouseMappingList(1)
        })
      })
    },
    getValueFromChild(obj) {
      this.routeWareHouseForm[obj.key] = obj.value
    },
    // 取消保存或者编辑
    cancelSaveOrEdit() {
      this.isShowRouteWareHouseMaintain = false
      this.routeWareHouseForm = this.initForm()
    },
    initForm() {
      return {
        uuid: '',
        regionCode: '',
        warehouseId: 0,
        remark: '',
        lob: 'SE',
        multipleOperateType: '',
        multipleCustomJobType: '',
        multipleLoadingPortCode: '',
        multiplePortCode: '',
        warehouseName: '',
        customsBroker: 0,
        destinationAgent: 0,
        multipleOpOffice: '',
        multipleCarrierId: '',
        arriveDateIncrement: 0,
        customerFileCutoffIncrement: 0,
        fileCutoffIncrement: 0,
        customerCutoffIncrement: 0,
        customCutoffIncrement: 0,
        customerShutoutIncrement: 0,
        portRequirement: '',
        dateCalculateIncludeCurrentDay: false,
        calculateIncludeEtdIsWeekend: true
      }
    },
    submitRouteWareHouseManagement() {
      const form = this.routeWareHouseForm
      if (!form.lob) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BusinessTypeCanTBeEmpty'))
        return
      }
      // if (!form.multipleOpOffice && !form.regionCode && !form.multipleOperateType && !form.multipleLoadingPortCode && !form.multiplePortCode && !form.multipleCustomJobType && !form.multipleCarrierId) {
      //   this.$message.warning(this.$t('SystemMaintenance.PleaseSelectMatchingItem'))
      //   return
      // }
      if (!form.warehouseId && !form.warehouseName && !form.customsBroker && !form.destinationAgent && !form.portRequirement &&
        !form.arriveDateIncrement && !form.customerFileCutoffIncrement && !form.fileCutoffIncrement && !form.customerCutoffIncrement && !form.customCutoffIncrement && !form.customerShutoutIncrement
      ) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSetPreset'))
        return
      }
      this.$confirm(this.$t('SystemMaintenance.ConfirmSaveModifiedInfo'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.saveRouteWareHouseManagement()
      }).catch(() => {})
    },
    saveRouteWareHouseManagement() {
      const loading = getLoading4Cxt(this)
      routeWarehouseMappingApi.save(this.routeWareHouseForm).then(res => {
        if (res.data.repeatPortCodes && res.data.repeatPortCodes.length > 0) {
          const portInfo = Array.from(
            res.data.repeatPortCodes,
            p => {
              if (this.isSeaOfForm || this.isIeOfForm) {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', p, 'auto_7')
              } else if (this.isAirOfForm) {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', p, 'auto_8')
              } else {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', p, 'auto_railway')
              }
            }
          ).join(',')
          this.$message.warning(this.$t('SystemMaintenance.PortCodeRepeat', [portInfo]))
          return
        } else if (res.data.repeatRegionCodes && res.data.repeatRegionCodes.length > 0) {
          const regionInfo = Array.from(
            res.data.repeatRegionCodes,
            p => {
              if (this.isSeaOfForm || this.isAirOfForm || this.isIeOfForm) {
                return ColumnUtils.resolveColumnLabelV2(TYPE_NAMES.basic_data_Region, 'code', p, 'name')
              } else {
                return ColumnUtils.resolveColumnLabelV2(TYPE_NAMES.basic_data_RailwayLine, 'code', p, 'name')
              }
            }
          ).join(',')
          this.$message.warning(this.$t('SystemMaintenance.RegionCodeRepeat', [regionInfo]))
          return
        }
        this.isShowRouteWareHouseMaintain = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
        JobUtils.regionPortPresetConfigCache.clear()
        this.fetchRouteWareHouseMappingList(1)
      }).finally(() => {
        loading.close()
      })
    },
    operateTypeLabelFunc(data) {
      let text = ''
      if (data.lob && data.multipleOperateType) {
        let operateTypes = []
        switch (data.lob) {
          case 'SE':
          case 'RE':
          case 'RI':
            operateTypes = Array.from(SeaExportConstants.CONTAINER_LOAD_TYPES)
            break
          case 'SI':
            operateTypes = ImportConstants._cargoTypeInputList
            break
          case 'AE':
            operateTypes = AirExportConstants.BUSINESS_MODELS
            break
          case 'AI':
            operateTypes = AirExportConstants.BUSINESS_MODELS
            break
          case 'IE':
            operateTypes = IE_TYPES
            break
        }
        const array = data.multipleOperateType.split(',')
        const isZh = this.$store.getters.language === 'zh'
        for (const item of array) {
          let commonState = null
          if (data.lob === 'AE' || data.lob === 'AI') {
            commonState = CommonState.getStateByCode(operateTypes, Number(item))
          } else {
            commonState = CommonState.getStateByCode(operateTypes, item)
          }
          if (commonState != null) {
            if (isZh) {
              if (text) {
                text = text + ',' + commonState.chineseName
              } else {
                text = commonState.chineseName
              }
            } else {
              if (text) {
                text = text + ',' + commonState.englishName
              } else {
                text = commonState.englishName
              }
            }
          }
        }
      }
      return text
    },
    getMultipleRegionName(data) {
      if (data.regionCode) {
        const regions = data.regionCode.split(',')
        if (data.lob === 'SE' || data.lob === 'SI' || data.lob === 'AE' || data.lob === 'AI' || data.lob === 'IE') {
          return Array.from(regions, p => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', p, 'name')).join(',')
        } else if (data.lob === 'RE' || data.lob === 'RI') {
          return Array.from(regions, p => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayLine, 'code', p, 'name')).join(',')
        }
      }
      return ''
    },
    getLoadingPortEnglishName(data) {
      if (data.multipleLoadingPortCode) {
        const codes = data.multipleLoadingPortCode.split(',')
        const names = []
        if (data.lob === 'SE' || data.lob === 'SI' || data.lob === 'IE') {
          for (const item of codes) {
            names.push(ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', item, 'englishName'))
          }
        } else if (data.lob === 'AE' || data.lob === 'AI') {
          for (const item of codes) {
            names.push(ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', item, 'englishName'))
          }
        } else if (data.lob === 'RE' || data.lob === 'RI') {
          for (const item of codes) {
            names.push(ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', item, 'englishName'))
          }
        }
        return names.length > 0 ? names.join(',') : ''
      }
      return ''
    },
    getPortEnglishName(data) {
      if (data.multiplePortCode) {
        const codes = data.multiplePortCode.split(',')
        const names = []
        if (data.lob === 'SE' || data.lob === 'SI' || data.lob === 'IE') {
          for (const item of codes) {
            names.push(ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', item, 'englishName'))
          }
        } else if (data.lob === 'AE' || data.lob === 'AI') {
          for (const item of codes) {
            names.push(ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', item, 'englishName'))
          }
        } else if (data.lob === 'RE' || data.lob === 'RI') {
          for (const item of codes) {
            names.push(ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', item, 'englishName'))
          }
        }
        return names.length > 0 ? names.join(',') : ''
      }
      return ''
    },
    async onWarehouseIdChange(data) {
      this.searchConditions.warehouseId = data.value || 0
      if (data.value > 0) {
        this.warehouseNameList = await new Company(data).getWarehouseDetail()
      } else {
        this.warehouseNameList = []
      }
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toArray(txt) {
      if (txt) {
        return txt.split(',')
      }
      return []
    },
    toTxt(strs) {
      if (strs && strs.length > 0) {
        return strs.join(',')
      }
      return ''
    },
    onMultipleRegionChange(data) {
      this.routeWareHouseForm.regionCode = this.toTxt(data.value)
      if (this.routeWareHouseForm.regionCode) {
        const regionList = this.routeWareHouseForm.regionCode.split(',')
        if (this.isSeaOfForm || this.isIeOfForm) {
          this.portList = getFilterCacheList(TYPE_NAMES.basic_data_Seaport, p => regionList.includes(p.region))
        } else {
          this.portList = getFilterCacheList(TYPE_NAMES.basic_data_Airport, p => regionList.includes(p.region))
        }
        if (this.routeWareHouseForm.multipleLoadingPortCode) {
          const portCodeList = this.routeWareHouseForm.multipleLoadingPortCode.split(',')
          const newPortCodeList = []
          for (const port of this.portList) {
            if (portCodeList.includes(port.code)) {
              newPortCodeList.push(port.code)
            }
          }
          this.routeWareHouseForm.multipleLoadingPortCode = this.toTxt(newPortCodeList)
        }
        if (this.routeWareHouseForm.multiplePortCode) {
          const portCodeList = this.routeWareHouseForm.multiplePortCode.split(',')
          const newPortCodeList = []
          for (const port of this.portList) {
            if (portCodeList.includes(port.code)) {
              newPortCodeList.push(port.code)
            }
          }
          this.routeWareHouseForm.multiplePortCode = this.toTxt(newPortCodeList)
        }
      } else {
        this.portList = []
        this.routeWareHouseForm.multipleLoadingPortCode = ''
        this.routeWareHouseForm.multiplePortCode = ''
      }
    },
    async onWarehouseIdFormChange(data) {
      this.routeWareHouseForm.warehouseId = data.value || 0
      this.routeWareHouseForm.warehouseName = ''
      if (data.value > 0) {
        this.warehouseNameFormList = await new Company(data).getWarehouseDetail()
        if (this.warehouseNameFormList.length > 0) {
          this.routeWareHouseForm.warehouseName = this.warehouseNameFormList[0].warehouseName
        }
      } else {
        this.warehouseNameFormList = []
      }
    },
    loadConfig() {
      getOfficeConfigByName({ officeId: 1, configName: 'useRouteWarehouseRemoteBooking' }).then(res => {
        this.config = res.data
      })
    },
    onConfigInput(val) {
      this.config.value = val ? '1' : '0'
      saveOfficeConfigFunc({
        officeId: this.config.officeId,
        configName: 'useRouteWarehouseRemoteBooking',
        configValue: this.config.value,
        overrideable: this.config.overrideable,
        version: this.config.version,
        uuid: this.config.uuid
      }).then(res => {
        this.loadConfig()
      })
    },
    openAttachment() {
      if (!this.routeWareHouseForm.uuid) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSaveCurrentDataFirst'))
        return
      }
      this.cloudFile.visible = true
    }
  }
}
</script>

<style scoped lang="scss">
.grid-view.app-main-page-tab  {
  .flex-column {
    display: flex;
    flex-direction: column;
  }
  .title {
    display: inline-block;
    position: relative;
    font-size: 13px;
    padding-left: 15px;
    line-height: 14px;
    margin-bottom: 10px;
  }
  .title:before {
    content: '';
    position: absolute;
    width: 4px;
    top: 0;
    left: 0;
    bottom: 0;
    background-color: #1F75D5;
  }
}
</style>
